import { Link, useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { baseUrl, instance } from "../../utils/APi";
import { Fragment } from "react";
import {
  addReview,
} from "../../store/products/productAction";
import { addingCart } from "../../store/cart/cartSlice";
import { failed, sucess } from "../../component/toast/Toast";
import img1 from "../../assets/222.jpeg";
import img2 from "../../assets/3-camera_lockup_white.png";
import img3 from "../../assets/7723324_orig.jpg";
import img4 from "../../assets/Lorex-Camera.png";
import img5 from "../../assets/cm104-1.jpg";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import Bread from "../../component/Bread";
const SingleProduct = () => {
  // const { t } = useTranslation();
  // const dispatch = useDispatch();
  // const lan = useSelector((state) => state.LanSlicer.language);
  // const { token } = useSelector((state) => state.authSlice);
  // const [singleProduct, setProduct] = useState(null);
  // const { productId } = useParams();

  // const fetchProduct = async () => {
  //   try {
  //     const response = await instance.get(`/api/product/${productId}`, {
  //       headers: {
  //         locale: lan,
  //       },
  //     });
  //     setProduct(response?.data?.data);
  //   } catch (error) {
  //     console.error("Error fetching product:", error);
  //   }
  // };
  // useEffect(() => {
  //   fetchProduct();
  // }, [productId, lan]);
  // const totalStars = singleProduct?.reviews?.reduce(
  //   (acc, review) => acc + review?.stars,
  //   0
  // );
  // const averageRating =
  //   singleProduct?.reviews?.length > 0
  //     ? totalStars / singleProduct?.reviews?.length
  //     : 0;

  // const [selectedImage, setSelectedImage] = useState();
  // const handleImageChange = (newImage) => {
  //   setSelectedImage(newImage);
  // };

  // useEffect(() => {
  //   if (singleProduct) {
  //     setSelectedImage(singleProduct?.product_photo);
  //   }
  // }, [singleProduct , lan , dispatch]);

  // const [selectedColor, setSelectedColor] = useState("");
  // const [selectedSize, setSelectedSize] = useState("");
  // const [quantity, setQuantity] = useState(1);


  // const addTOCart = () => {
  //   const cartItem = {
  //     productId: singleProduct?.id,
  //     productName: singleProduct?.name,
  //     productPhoto: singleProduct?.product_photo || singleProduct?.image,
  //     quantity: quantity,
  //     price:
  //       singleProduct?.discount_price && singleProduct?.discount_price !== 0
  //         ? singleProduct?.discount_price
  //         : singleProduct?.price,
  //     color: selectedColor,
  //     size: selectedSize,
  //   };
    
  //   dispatch(addingCart({ cartItem }));
  //   sucess(t("added successfully"));
  // };
 
  // const [formData, setFormData] = useState({
  //   product_id: singleProduct?.id,
  //   stars: 0,
  //   name: "",
  //   review: "",
  // });

  // const handleChange = (e) => {
  //   const { id, value } = e.target;
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     product_id: singleProduct?.id,
  //     [id]: value,
  //   }));
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (token) {
  //     dispatch(addReview({ formData, token }));
  //     sucess(t("your review have been added succefuuly"));
  //   } else {
  //     failed(t("first you must have an account"));
  //   }
  //   setFormData({
  //     product_id: null,
  //     stars: 0,
  //     name: "",
  //     review: "",
  //   });
  // };
    // Track the active tab with state
    const [mainImage, setMainImage] = useState(img5);
    const [selectedColor, setSelectedColor] = useState("");
    const [selectedSize, setSelectedSize] = useState("");
    const [quantity, setQuantity] = useState(1);
    const [activeTab, setActiveTab] = useState('description');

    // Function to handle tab click
    const handleTabClick = (tab) => {
      setActiveTab(tab);
    };
  

    const images = [img1, img2, img3, img4, img5];

  // Update main image on thumbnail click
  const handleThumbnailClick = (img) => {
    setMainImage(img);
  };
  return (
    <Fragment> 
    <Bread title={"Home"} sub={"Product"}  span={"itemv 22"}/>
    <section className="section-wrap single-product">
      <div className="container relative">
        <div className="row">

     <div className="col-sm-6 col-xs-12 mb-60">
       <div className="flickity flickity-slider-wrap mfp-hover" id="gallery-main">
        <div className="gallery-cell parent-gallery-cell">
        
            <img src={mainImage} alt="" className="main-grid-img" />
            
         
        </div>
      </div>

      <div className="gallery-thumbs">
        {images.map((img, index) => (
          <div
            key={index}
            className="gallery-cell"
            onClick={() => handleThumbnailClick(img)}
            style={{ cursor: 'pointer' }}
          >
            <img src={img} alt="" />
          </div>
        ))}
      </div>
    </div>

          <div className="col-sm-6 col-xs-12 product-description-wrap">
            <h1 className="product-title">Summer Dress</h1>
            <span className="rating">
              <a href="#">3 Reviews</a>
            </span>
            <span className="price">
              <del>
                <span>$1550.00</span>
              </del>
              <ins>
                <span className="ammount">$1250.00</span>
              </ins>
            </span>
            <p className="product-description">A-ha Shop is a very slick and clean e-commerce template with endless possibilities. Creating an awesome clothes store with this Theme is easy than you can imagine</p>

            <div className="select-options">
              <div className="row row-20">
                <div className="col-sm-6">
                  <select className="color-select">
                    <option value>Select color</option>
                    <option value="white">white</option>
                    <option value="grey">grey</option>
                    <option value="black">black</option>
                    <option value="green">green</option>
                    <option value="blue">blue</option>
                  </select>
                </div>

                <div className="col-sm-6">
                  <select className="size-options">
                    <option value>Select size</option>
                    <option value="XS">XS</option>
                    <option value="S">S</option>
                    <option value="M">M</option>
                    <option value="L">L</option>
                    <option value="XL">XL</option>
                  </select>
                </div>
              </div>
            </div>

            <ul className="product-actions clearfix">
              
              <li>
                <a href="#" className="btn btn-color btn-lg add-to-cart left"><span>Add to Cart</span></a>
              </li>                
              <li>
                <div className="icon-add-to-wishlist left">
                  <a href="#"><i className="icon icon_heart_alt"></i></a>
                </div>
              </li> 
              <li>
                <div className="quantity buttons_added">
                  <input type="button" value="-" className="minus" /><input type="number" step="1" min="0" value="1" title="Qty" className="input-text qty text" /><input type="button" value="+" className="plus" />
                </div>
              </li>          
            </ul>

            <div className="product_meta">
              <span className="sku">SKU: <a href="#">111763</a></span>
              <span className="posted_in">Category: <a href="#">Accessories</a></span>
              <span className="tagged_as">Tags: <a href="#">Elegant</a>, <a href="#">Bag</a></span>
            </div>

            <div className="socials-share clearfix">
              <div className="social-icons rounded">
                <a href="#"><i className="fa fa-twitter"></i></a>
                <a href="#"><i className="fa fa-facebook"></i></a>
                <a href="#"><i className="fa fa-google-plus"></i></a>
                <a href="#"><i className="fa fa-linkedin"></i></a>
                <a href="#"><i className="fa fa-vimeo"></i></a>
              </div>
            </div>
          </div> 
        </div> 

    
        <div className="row">
      <div className="col-md-12">
        <div className="tabs tabs-bb">
          <ul className="nav nav-tabs">
            <li className={activeTab === 'description' ? 'active' : ''}>
              <a onClick={() => handleTabClick('description')}>Description</a>
            </li>
            <li className={activeTab === 'info' ? 'active' : ''}>
              <a onClick={() => handleTabClick('info')}>Information</a>
            </li>
            <li className={activeTab === 'reviews' ? 'active' : ''}>
              <a onClick={() => handleTabClick('reviews')}>Reviews</a>
            </li>
          </ul>

          <div className="tab-content">
            {/* Description Tab */}
            <div
              className={`tab-pane fade ${activeTab === 'description' ? 'in active' : ''}`}
              id="tab-description"
            >
              <p>
                We possess within us two minds. So far I have written only of the conscious mind.
                I would now like to introduce you to your second mind, the hidden and mysterious
                subconscious. Our subconscious mind contains such power and complexity that it
                literally staggers the imagination. And finally, the subconscious is the mechanism
                through which thought impulses which are repeated regularly with feeling and emotion
                are quickened, charged.
              </p>
            </div>

            <div
              className={`tab-pane fade ${activeTab === 'info' ? 'in active' : ''}`}
              id="tab-info"
            >
              <table className="table">
                <tbody>
                  <tr>
                    <th>CPU</th>
                    <td>2.7GHz quad-core Intel Core i5 Turbo Boost up to 3.2GHz</td>
                  </tr>
                  <tr>
                    <th>RAM</th>
                    <td>8GB (two 4GB) memory</td>
                  </tr>
                  <tr>
                    <th>Video</th>
                    <td>Intel Iris Pro Graphics</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Reviews Tab */}
            <div
              className={`tab-pane fade ${activeTab === 'reviews' ? 'in active' : ''}`}
              id="tab-reviews"
            >
              <div className="reviews">
                <ul className="reviews-list">
                  <li>
                    <div className="review-body">
                      <div className="review-content">
                        <p className="review-author">
                          <strong>Alexander Samokhin</strong> - May 6, 2014 at 12:48 pm
                        </p>
                        <div className="rating">
                          <a href="#"></a>
                        </div>
                        <p>
                          This template is so awesome. I didn’t expect so many features inside.
                          E-commerce pages are very useful; you can launch your online store in a few
                          seconds. I will rate 5 stars.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="review-body">
                      <div className="review-content">
                        <p className="review-author">
                          <strong>Christopher Robins</strong> - May 6, 2014 at 12:48 pm
                        </p>
                        <div className="rating">
                          <a href="#"></a>
                        </div>
                        <p>
                          This template is so awesome. I didn’t expect so many features inside.
                          E-commerce pages are very useful; you can launch your online store in a few
                          seconds. I will rate 5 stars.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      </div> 
    </section>
    </Fragment>
  );
};

export default React.memo(SingleProduct);
